import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CarriersListComponent } from './components/carriers-list/carriers-list.component';
import { CoverageMapComponent } from './components/coverage-map/coverage-map.component';

const routes: Routes = [
  { path: 'carriers-list', component: CarriersListComponent },
  { path: ':carrierId/coverage-map', component: CoverageMapComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CarriersRoutingModule { }
